/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconHuiyuanka: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1303 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M1169.314909 744.401455c-0.139636-31.325091-19.502545-47.010909-66.932364-45.707637-10.891636 1.117091-18.245818 1.117091-21.783272 0v81.547637c3.723636 0 10.845091 1.675636 21.783272 1.675636 48.267636 0 66.932364-11.450182 66.932364-37.515636zM1221.911273 0H81.361455C36.398545 0 0 35.793455 0 80.058182v111.988363h1303.272727V80.011636C1303.272727 35.933091 1266.874182 0 1221.911273 0zM0 943.941818C0 988.113455 36.398545 1024 81.361455 1024h1140.363636c44.962909 0 81.361455-35.793455 81.361454-80.058182V256H0v687.941818z m1114.437818-291.84c70.562909-0.977455 105.797818 27.648 105.797818 86.016-1.815273 54.318545-31.930182 83.083636-90.251636 86.062546h-40.913455v107.147636h-55.016727v-279.272727h80.384zM930.909091 651.636364h46.545454v279.272727h-46.545454v-279.272727z m-258.792727 0l74.938181 220.532363h1.489455L823.482182 651.636364H884.363636l-106.123636 279.272727h-67.165091L605.090909 651.636364h67.025455z"
        fill={getIconColor(color, 0, '#A78627')}
      />
    </svg>
  );
};

IconHuiyuanka.defaultProps = {
  size: 18,
};

export default IconHuiyuanka;
